import { render, staticRenderFns } from "./regList.vue?vue&type=template&id=0004ee0a&"
import script from "./regList.vue?vue&type=script&lang=js&"
export * from "./regList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports